



















































import "@/assets/css/split.css";
import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import CreatePressureModal from "./createpressuremodal.vue";
import EditPressureModel from "./editpressuremodal.vue";
import CopyPressureModel from "./copypressuremodal.vue";
import checkAuth from "@/lib/Common/checkauth";
import "@/assets/css/table.css";

class PagePressureModelRequest extends PageRequest {
  keyword: string;
  areaId: number;
}

@Component({
  components: { CreatePressureModal, EditPressureModel, CopyPressureModel },
})
export default class pressuremodal extends AbpBase {
  edit() {
    this.editModalShow = true;
  }
  //filters
  pagerequest: PagePressureModelRequest = new PagePressureModelRequest();
  creationTime: Date[] = [];
  searchName: string = ""; //树形搜索名称
  areaTree: any[] = [];
  areaTreeList: any[] = [];
  createModalShow: boolean = false;
  editModalShow: boolean = false;
  copyModalShow: boolean = false;
  height: number = 300;
  splitnum: number = 0.15;
  //检测按钮权限
  checkButtonAuth(tag: string) {
    return checkAuth.CheckButton(tag);
  }
  changeSort(key) {
    if (key.order !== "normal") {
      this.pagerequest.sorting = key.key + " " + key.order;
    }
    this.getpage();
  }
  get list() {
    return this.$store.state.pressuremodel.list;
  }
  get loading() {
    return this.$store.state.pressuremodel.loading;
  }
  create() {
    this.createModalShow = true;
  }
  isActiveChange(val: number) {
    this.$store.commit("pressuremodel/setCurrentPage", 1);
    this.getpage();
  }
  getItemId() {
    let item = (this.$refs.tree as any).getSelectedNodes();
    if (item.length > 0) {
      this.pagerequest.areaId = item[0].id;
    }
    this.$store.commit("pressuremodel/setCurrentPage", 1);
    this.getpage();
  }
  //搜索树形结构
  searchTree(value: any, treeList) {
    if (!value) {
      this.areaTree = this.areaTreeList;
      return;
    }
    const rebuildData = (value, treeList) => {
      let newarr = [];
      treeList.forEach((element) => {
        if (element.children && element.children.length) {
          if (element.children && element.title.indexOf(value) > -1) {
            element.expand = true;
            newarr.push(element);
          }
          const ab = rebuildData(value, element.children);
          const obj = {
            ...element,
            expand: true,
            children: ab,
          };
          if (ab && ab.length) {
            newarr.push(obj);
          }
        } else {
          if (element.children && element.title.indexOf(value) > -1) {
            newarr.push(element);
          }
        }
      });
      return newarr;
    };
    this.areaTree = [];
    this.areaTree = rebuildData(value, this.areaTreeList);
  }
  async getAreaTree() {
    await this.$store
      .dispatch("area/getAreaLeftTree")
      .then((val) => {
        this.areaTree = val;
        this.areaTreeList = val;
      })
      .catch((err) => {
        //return null;
      });
  }
  pageChange(page: number) {
    this.$store.commit("pressuremodel/setCurrentPage", page);
    this.getpage();
  }
  pagesizeChange(pagesize: number) {
    this.$store.commit("pressuremodel/setPageSize", pagesize);
    this.getpage();
  }
  async getpage() {
    this.pagerequest.maxResultCount = this.pageSize;
    this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
    await this.$store.dispatch({
      type: "pressuremodel/getAll",
      data: this.pagerequest,
    });
  }
  get pageSize() {
    return this.$store.state.pressuremodel.pageSize;
  }
  get totalCount() {
    return this.$store.state.pressuremodel.totalCount;
  }
  get currentPage() {
    return this.$store.state.pressuremodel.currentPage;
  }
  columns = [
    {
      type: "index",
      width: 60,
      align: "left",
      fixed: "left",
      title: this.L("IndexNo"),
    },
    {
      title: this.L("Areas"),
      key: "areaId",
      sortable: true,
      width: 160,
      render: (h: any, params: any) => {
        let id = params.row.areaId;
        let ite = JSON.parse(localStorage.getItem("areas"));
        let info = ite.filter((p) => {
          return p.id == id;
        });
        return h("div", [
          h(
            "span",
            {
              style: {
                display: "inline-block",
                width: "100%",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              },
              domProps: { title: info.length > 0 ? info[0].fullName : this.L("Unknown") },
            },
            info.length > 0 ? info[0].fullName : this.L("Unknown")
          ),
        ]);
      },
    },
    {
      title: this.L("Name"),
      key: "name",
      width: 160,
      fixed: "left",
    },
    {
      title: this.L("MeterType"),
      key: "meterType",
      width: 160,
      render: (h: any, params: any) => {
        let id = params.row.meterType;
        let ite = JSON.parse(localStorage.getItem("itemdetail"));
        let info = ite.filter((p) => {
          return p.id == id;
        });
        return h("span", info.length > 0 ? info[0].name : this.L("Unknown"));
      },
    },
    {
      title: this.L("DeviceType"),
      key: "deviceType",
      width: 160,
      render: (h: any, params: any) => {
        let id = params.row.deviceType;
        let ite = JSON.parse(localStorage.getItem("itemdetail"));
        let info = ite.filter((p) => {
          return p.id == id;
        });
        return h("span", info.length > 0 ? info[0].name : this.L("Unknown"));
      },
    },
    {
      title: this.L("ISP"),
      key: "isp",
      width: 130,
      render: (h: any, params: any) => {
        let id = params.row.isp;
        console.log(id)
        let ite = JSON.parse(localStorage.getItem("itemdetail"));
        let info = ite.filter((p) => {
          return p.id == id;
        });
        console.log(info)
        return h("span", info.length > 0 ? info[0].name : this.L("Unknown"));
      },
    },
    {
      title: this.L("Transfer") + this.L("Category"),
      key: "transferType",
      width: 130,
      sortable: true,
      sortId: 21,
      render: (h: any, params: any) => {
        let id = params.row.transferType;
        let ite = JSON.parse(localStorage.getItem("itemdetail"));
        let info = ite.filter((p) => {
          return p.id == id;
        });
        return h("span", info.length > 0 ? info[0].name : "未知");
      },
    },
    {
      title: "AppId",
      key: "appId",
      width: 130,
      render: (h: any, params: any) => {
        return h("div", [
          h(
            "span",
            {
              style: {
                display: "inline-block",
                width: "100%",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              },
              domProps: { title: params.row.appId },
            },
            params.row.appId
          ),
        ]);
      },
    },
    {
      title: "AppSecret",
      key: "appSecret",
      width: 130,
      render: (h: any, params: any) => {
        return h("div", [
          h(
            "span",
            {
              style: {
                display: "inline-block",
                width: "100%",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              },
              domProps: { title: params.row.appSecret },
            },
            params.row.appSecret
          ),
        ]);
      },
    },
    {
      title: this.L("Protocol"),
      key: "protocol",
      width: 160,
      render: (h: any, params: any) => {
        let id = params.row.protocol;
        let ite = JSON.parse(localStorage.getItem("itemdetail"));
        let info = ite.filter((p) => {
          return p.id == id;
        });
        return h("span", info.length > 0 ? info[0].name : this.L("Unknown"));
      },
    },
    {
      title: this.L("Unit"),
      key: "unitName",
      width: 130,
    },
    {
      title: this.L("Magnification"),
      key: "magnification",
      width: 130,
    },
    {
      title: this.L("Tenants") + "Id",
      key: "aepTenantId",
      width: 130,
    },
    {
      title: this.L("Product") + "Id",
      key: "productId",
      width: 130,
      render: (h: any, params: any) => {
        return h("div", [
          h(
            "span",
            {
              style: {
                display: "inline-block",
                width: "100%",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              },
              domProps: { title: params.row.productId },
            },
            params.row.productId
          ),
        ]);
      },
    },
    {
      title: this.L("MasterId"),
      key: "masterId",
      width: 130,
      render: (h: any, params: any) => {
        return h("div", [
          h(
            "span",
            {
              style: {
                display: "inline-block",
                width: "100%",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              },
              domProps: { title: params.row.masterId },
            },
            params.row.masterId
          ),
        ]);
      },
    },
    {
      title: this.L("Manufacturer") + "Id",
      key: "manufacturerId",
      width: 130,
    },
    {
      title: this.L("Manufacturer") + this.L("Name"),
      key: "manufacturerName",
      width: 130,
    },
    {
      title: this.L("Device") + this.L("Model"),
      key: "deviceModel",
      width: 130,
    },
    {
      title: this.L("Object") + "Id",
      key: "obj_Id",
      width: 130,
    },
    {
      title: this.L("Inst") + "Id",
      key: "obj_Inst_id",
      width: 130,
    },
    {
      title: this.L("Resource") + "Id",
      key: "res_Id",
      width: 130,
    },
    {
      title: this.L("Supplier"),
      key: "supplierId",
      width: 130,
      sortable: true,
      sortId: 20,
      render: (h: any, params: any) => {
        let id = params.row.supplierId;
        let ite = JSON.parse(localStorage.getItem("suppliers"));
        let info = ite.filter((p) => {
          return p.id == id;
        });
        return h("span", info.length > 0 ? info[0].name : "未知");
      },
    },
    {
      title: "Id",
      key: "id",
      width: 130,
    },
    {
      title: this.L("Actions"),
      key: "Actions",
      width: 180,
      fixed: "right",
      render: (h: any, params: any) => {
        let del = this.checkButtonAuth('pressuremodalDel');
        let edit = this.checkButtonAuth('pressuremodalEdit');
        let copy = this.checkButtonAuth('pressuremodalCopy');
        return h("div", [
          edit ? h(
            "Button",
            {
              props: {
                type: "primary",
                size: "small",
              },
              style: {
                marginRight: "5px",
              },
              on: {
                click: () => {
                  this.$store.commit("pressuremodel/edit", params.row);
                  this.edit();
                },
              },
            },
            this.L("Edit")
          ) : '',
          copy ? h(
            "Button",
            {
              props: {
                type: "success",
                size: "small",
              },
              style: {
                marginRight: "5px",
              },
              on: {
                click: () => {
                  this.$store.commit("pressuremodel/edit", params.row);
                  this.copy();
                },
              },
            },
            this.L("Copy")
          ) : '',
          del ? h(
            "Button",
            {
              props: {
                type: "error",
                size: "small",
              },
              on: {
                click: async () => {
                  this.$Modal.confirm({
                    title: this.L("Tips"),
                    content: this.L("DeleteConfirm"),
                    okText: this.L("Yes"),
                    cancelText: this.L("No"),
                    onOk: async () => {
                      await this.$store.dispatch({
                        type: "pressuremodel/delete",
                        data: params.row,
                      });
                      await this.getpage();
                    },
                  });
                },
              },
            },
            this.L("Delete")
          ) : '',
        ]);
      },
    },
  ];
  async created() {
    this.getpage();
    this.getAreaTree();
  }
  data() {
    return {
      ispdetail: [],
      normalizer(node) {
        if (node.children && !node.children.length) {
          delete node.children;
        }
        return {
          id: node.id,
          label: node.label,
          children: node.children,
        };
      },
    };
  }
  //复制
  async copy() {
    this.copyModalShow = true;
  }
  mounted() {
    if (window.innerHeight > 800) {
      this.height = window.innerHeight - 350;
    } else {
      this.height = window.innerHeight - 100;
    }
  }
}
